import { render, staticRenderFns } from "./manage-member.vue?vue&type=template&id=d5369136&scoped=true"
import script from "./manage-member.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-member.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-member.vue?vue&type=style&index=0&id=d5369136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5369136",
  null
  
)

export default component.exports